module.exports = __webpack_public_path__ + "static/media/home-landing-image-07.4689135c.jpg";